import { Button, Link, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { ContactSales } from './contact-sales';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 40,
    position: 'relative',
    zIndex: 100,
  },
  header: {
    color: 'rgb(32,33,36)',
    fontWeight: 500,
    margin: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      lineHeight: '40px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 38,
      letterSpacing: -0.43,
      lineHeight: '52px',
    },
  },
  info: {
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    alignSelf: 'center',
    maxWidth: 670,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 30,
    },
  },
}));

export const Contact: FC<{ isComplete: boolean }> = ({ isComplete }) => {
  const { root, header, info } = useStyles();

  return (
    <div className={root} style={{ marginTop: isComplete ? 40 : undefined }}>
      <h3 className={header}>Accelerate your data transformation.</h3>
      <p className={info}>
        See why top companies build their data clouds with Google Cloud.
      </p>
      <Link
        underline="none"
        target="blank"
        href={`https://cloud.google.com/data-cloud?utm_source=google&utm_medium=blog&utm_campaign=FY21-Q2-northam-NA1007-website-dl-data_transformation_p2_assessment_form&utm_content=data-trans-assessment`}
      >
        <Button color="primary" variant="contained" style={{ width: 180 }}>
          Learn more
        </Button>
      </Link>
      {isComplete ? (
        <ContactSales />
      ) : null}
    </div>
  );
};
